import { convertToIsoDateTime } from "../datetime";

export const selfExclusionCreatePayload = (data, siteGuid) => {
  return {
    ...data,
    selfExclusionDate: convertToIsoDateTime(data.date, data.time),
    site: { guid: siteGuid },
  };
};
